import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { getActiveTab } from './helpers';
import { TAB, TABS, SIDEPANEL, CONTENT_GROUP, PANEL } from './constants';
const ContentGroupTabs = ({
  name,
  contentType,
  groupSections,
  sectionsData,
  VariantComponent
}) => {
  const router = useRouter();
  const [selectedTab, setSelectedTab] = useState(getActiveTab(sectionsData, ''));
  const {
    asPath
  } = router;
  const contentClassame = contentType === TAB ? TABS : SIDEPANEL;
  const mainDivClass = `${CONTENT_GROUP}-${contentClassame}`;
  const contentGroupClass = `${CONTENT_GROUP}-${contentClassame}__buttons-wrapper`;
  const sectionClass = `${CONTENT_GROUP}-${contentClassame}__content-section`;
  useEffect(() => {
    const activeTab = getActiveTab(sectionsData, asPath);
    if (activeTab !== selectedTab) setSelectedTab(activeTab);
  }, [asPath, sectionsData, selectedTab]);
  const WrapperComponent = VariantComponent || 'div';
  return /*#__PURE__*/React.createElement("div", {
    className: mainDivClass
  }, /*#__PURE__*/React.createElement("ul", {
    className: contentGroupClass,
    role: "tablist",
    "aria-label": name
  }, groupSections.map((_, index) => {
    const [sectionName, sectioLabel] = sectionsData[index];
    const tabId = `${TAB}-${sectionName}`;
    const isSelected = selectedTab === tabId;
    const buttonClassName = `${CONTENT_GROUP}-${contentClassame}__button${isSelected ? '--is-active' : ''}`;
    return /*#__PURE__*/React.createElement("button", {
      id: tabId,
      key: tabId,
      className: buttonClassName,
      type: "button",
      role: "tab",
      "aria-selected": isSelected,
      "aria-controls": sectionName,
      onClick: () => {
        const baseUrl = asPath.split('#')[0];
        const newUrl = `${baseUrl}#${sectionName}`;
        if (asPath === newUrl) return;
        router.push(`/Resolver`, newUrl, {
          shallow: true
        });
      }
    }, sectioLabel);
  })), groupSections.map((groupSection, index) => {
    const [sectionName] = sectionsData[index];
    const tabId = `${TAB}-${sectionName}`;
    const panelId = `${PANEL}-${sectionName}`;
    if (selectedTab !== tabId) return null;
    return /*#__PURE__*/React.createElement(WrapperComponent, {
      key: panelId,
      id: sectionName,
      className: sectionClass,
      role: "tabpanel",
      tabId: tabId,
      "aria-labelledby": tabId
    }, groupSection);
  }));
};
ContentGroupTabs.propTypes = {
  name: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  groupSections: PropTypes.array.isRequired,
  sectionsData: PropTypes.array.isRequired,
  VariantComponent: PropTypes.func
};
ContentGroupTabs.defaultProps = {
  VariantComponent: null
};
export default ContentGroupTabs;
//# sourceMappingURL=ContentGroupTabs.js.map